var ng;

require('./multi_order_by');

require('./st_element_id');

require('./st_shift_click');

ng = angular;

angular.module('smart-table').directive('stMultiSort', [
  'stConfig', '$parse', '$rootScope', 'stUniqueId', 'stShiftSort', function(stConfig, $parse, $rootScope, stUniqueId, stShiftSort) {
    return {
      restrict: 'A',
      require: '^stTable',
      link: function(scope, element, attr, ctrl) {
        var classAscent, classDescent, elementId, getter, index, predicate, sort, sortDefault, stateClasses;
        predicate = attr.stMultiSort;
        getter = $parse(predicate);
        index = 0;
        classAscent = attr.stClassAscent || stConfig.sort.ascentClass;
        classDescent = attr.stClassDescent || stConfig.sort.descentClass;
        stateClasses = [classAscent, classDescent];
        sortDefault = void 0;
        elementId = stUniqueId.generate();

        /*
        Use our custom orderBy filter, which supports reversing rows independently
         */
        ctrl.setSortFunction('multiOrderBy');

        /*
        Sort the rows.
        @param {Boolean} holdingShiftKey
         */
        sort = function(holdingShiftKey) {
          var base, reverse, tableState;
          index++;
          tableState = ctrl.tableState();
          if ((base = tableState.sort).predicate == null) {
            base.predicate = [];
          }
          reverse = index % 2 === 0;
          predicate = ng.isFunction(getter(scope)) ? getter(scope) : attr.stMultiSort;
          (function() {
            var indexOfExistingSort;
            indexOfExistingSort = (function() {
              var i, ref, sortConfig;
              ref = ctrl.tableState().sort.predicate;
              for (i in ref) {
                sortConfig = ref[i];
                if (sortConfig.elementId === elementId) {
                  return i;
                }
              }
              return -1;
            })();
            if (indexOfExistingSort !== -1) {
              return tableState.sort.predicate.splice(indexOfExistingSort, 1);
            }
          })();
          (function() {
            index = index % 2 === 0 ? 2 : 1;
            element.removeClass(stateClasses[index % 2]).addClass(stateClasses[index - 1]);
            if (!holdingShiftKey) {
              return $rootScope.$broadcast('clearOtherSortClasses', elementId);
            }
          })();
          tableState.sort.predicate.splice(stShiftSort.getIndex(elementId), 0, {
            elementId: elementId,
            predicate: predicate,
            reverse: reverse === true
          });
          tableState.pagination.start = 0;
          return ctrl.pipe();
        };
        if (attr.stSortDefault) {
          sortDefault = scope.$eval(attr.stSortDefault) != null ? scope.$eval(attr.stSortDefault) : attr.stSortDefault;
        }
        if (sortDefault) {
          index = sortDefault === 'reverse' ? 1 : 0;
          sort();
        }
        element.bind('click', function(e) {
          if (!predicate) {
            return;
          }
          if (e.shiftKey || e.ctrlKey) {
            stShiftSort.clickElement(elementId);
          } else {
            stShiftSort.clear();
          }
          return scope.$apply(function() {
            return sort(e.shiftKey || e.ctrlKey);
          });
        });
        return scope.$on('clearOtherSortClasses', function(e, sortedElementId) {
          if (sortedElementId !== elementId) {
            index = 0;
            return element.removeClass(classAscent).removeClass(classDescent);
          }
        });
      }
    };
  }
]);

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
